export const LAYOUT = {
  MOBILE_MAX: "560px",
  TABLET_MAX: "1024px",
  DESKTOP_MIN: "1025px",
};

// We follow the viewport dimensions that align with LAYOUT breakpoints above.
// However, those values represent the maximum width for the specified breakpoints. For
// instances like our `device-toggle-component`, we'll want the component to show a slightly
// thinner UI for the specified devices.
const MIN_MOBILE_WIDTH = "460px";
const MIN_TABLET_WIDTH = "767px";
const MIN_DESKTOP_WIDTH = "1224px";

// Name of cookie containing user selected locale.
// This name comes from Hopin Dashbaord (where the locale selector lives)
// https://gitlab.com/hopin.com/Product/Hopin/-/blob/develop/app/javascript/react/features/localization/constants.js#L26
export const COOKIE_LOOKUP_KEY_LANG = "i18next";

export const defaultLocale = "en";

export const SUPPORTED_LOCALES = [
  "de-DE",
  "ja-JP",
  "zh-CN",
  "zh-TW",
  "nl-NL",
  "fr-FR",
  "it-IT",
  "ko-KR",
  "pl-PL",
  "pt-BR",
  "es-419",
  defaultLocale,
  /* en.json being the input file and to be used as a global fallback
  TODO: Other 4 char English outputs (en-**.json) will be configured in the future */
] as const;

export const languageToLocaleMap: Record<
  string,
  typeof SUPPORTED_LOCALES[number]
> = {
  de: "de-DE",
  ja: "ja-JP",
  zh: "zh-CN",
  nl: "nl-NL",
  fr: "fr-FR",
  it: "it-IT",
  ko: "ko-KR",
  pl: "pl-PL",
  pt: "pt-BR",
  es: "es-419",
  en: defaultLocale,
};

/**
 * Converts 4 character long locale to 2 characters
 * When a match is not found, default value of "en" is returned.
 *
 * Examples:
 * - mapLocaleToLanguage("ja-JP") => "ja"
 * - mapLocaleToLanguage("it-IT") => "it"
 * - mapLocaleToLanguage("nonsense") => "en"
 */
export const mapLocaleToLanguage = (locale = "") => {
  let response = defaultLocale;

  for (const [key, value] of Object.entries(languageToLocaleMap)) {
    if (value === locale) {
      response = key;
    }
  }

  return response;
};

export const UI_MODAL_BREAKPOINTS = {
  LARGE: 632,
};

export const IMAGE_USAGE_PROP_NAME = "__imageUsageId";

export { MIN_MOBILE_WIDTH, MIN_TABLET_WIDTH, MIN_DESKTOP_WIDTH };
